import { string } from '@/shared/libs/yup';
import { HookFormField, FieldInputProps } from '@/shared/libs/hook-form';

export const emailSchema = string().simpleEmail().label('Email');

export const EmailField = (props: FieldInputProps) => <HookFormField.Input label="Email" type="email" {...props}/>;